export default __webpack_public_path__ + "static/media/rocket_anim_2.281fdf6c.png";